export const KITCHEN_DINING_PATH_SEPARATOR = ' > ';
export const KITCHEN_DINING_ROOT = 'Kitchen & Dining';

export const KITCHEN_DINING_CATEGORY_TREE = {
  'Kitchen Appliances': [
    'Microwaves',
    'Air Fryers',
    'Blenders & Mixers',
    'Coffee Machines',
    'Kettles',
    'Toasters & Sandwich Makers',
    'Food Processors',
    'Juicers',
    'Rice Cookers',
    'Electric Grills',
    'Water Dispensers',
    'Refrigerators & Freezers',
    'Dishwashers',
    'Other Appliances',
  ],
  Cookware: [
    'Pots',
    'Pans & Frying Pans',
    'Pressure Cookers',
    'Casseroles & Dutch Ovens',
    'Baking Trays & Dishes',
    'Cake Pans & Molds',
    'Cooking Sets',
    'Other Cookware',
  ],
  Tableware: [
    'Dinner Plates',
    'Bowls',
    'Cups & Mugs',
    'Drinking Glasses',
    'Tea & Coffee Sets',
    'Glass Jugs & Pitchers',
    'Dinner Sets',
    'Other Tableware',
  ],
  'Utensils & Tools': [
    'Spoon & Fork Sets',
    'Knives & Knife Sets',
    'Cooking Utensils',
    'Measuring Tools',
    'Peelers & Graters',
    'Strainers & Colanders',
    'Cutting Boards',
    'Kitchen Gadgets',
    'Other Utensils & Tools',
  ],
  'Storage Containers': [
    'Food Containers',
    'Lunch Boxes',
    'Storage Jars',
    'Spice Containers',
    'Water Bottles & Flasks',
    'Kitchen Organizers',
    'Storage Baskets',
    'Other Storage Containers',
  ],
  'Serving & Dining': [
    'Serving Trays',
    'Serving Bowls',
    'Serving Plates & Platters',
    'Cake Stands',
    'Serving Utensils',
    'Table Accessories',
    'Decorative Serving Pieces',
    'Other Serving & Dining',
  ],
  'Towels & Aprons': [
    'Aprons',
    'Kitchen Towels',
    'Oven Mitts & Pot Holders',
    'Tablecloths',
    'Placemats',
    'Napkins',
    'Other Kitchen Textiles',
  ],
};

export const KITCHEN_DINING_GROUPS = Object.keys(KITCHEN_DINING_CATEGORY_TREE);

export function isHomeKitchenListingCategory(category) {
  return category === 'Home & Kitchen' || category === 'Home & Garden';
}

export function isKitchenDiningSubcategory(subcategory) {
  if (!subcategory) return false;
  return (
    subcategory === KITCHEN_DINING_ROOT ||
    subcategory.startsWith(`${KITCHEN_DINING_ROOT}${KITCHEN_DINING_PATH_SEPARATOR}`)
  );
}

export function joinKitchenDiningSubcategoryPath(parts) {
  return parts.filter(Boolean).join(KITCHEN_DINING_PATH_SEPARATOR);
}

export function parseKitchenDiningSubcategoryPath(value) {
  if (!value || !isKitchenDiningSubcategory(value)) {
    return { root: '', group: '', type: '' };
  }
  const [root = '', group = '', type = ''] = String(value).split(KITCHEN_DINING_PATH_SEPARATOR);
  return { root, group, type };
}

export function getKitchenDiningTypes(group) {
  return KITCHEN_DINING_CATEGORY_TREE[group] || [];
}
